import React from "react";
import { Loader2 } from "lucide-react";
import { formatReferralCash, getReferralRowDate } from "../../utils/referralsHelpers";

const monogram = (name = "") => (String(name).trim()[0] || "U").toUpperCase();

const ReferralListRow = ({
  item,
  unlockScoreThreshold,
  rewardAmount,
  claiming,
  onClaim,
}) => {
  const isPending = item.status === "pending";
  const isRewarded = item.status === "rewarded";
  const canClaim = Boolean(item.canClaim);
  const score = item.referee?.allTimeScores ?? 0;
  const betPlaced = Boolean(item.hasQualifyingBet);
  const rowDate = getReferralRowDate(item);
  const rewardLabel = isRewarded
    ? formatReferralCash(item.earnedCash)
    : formatReferralCash(rewardAmount);

  const progress = Math.round(item.progressPercent || 0);

  return (
    <article className={`ref-row ref-row-${item.status || "pending"}`}>
      <span className="ref-row-avatar" aria-hidden>
        {monogram(item.referee?.name)}
      </span>

      <div className="ref-row-body">
        <div className="ref-row-primary">
          <strong className="ref-row-name">{item.referee?.name || "User"}</strong>
        </div>

        {isPending ? (
          <div className="ref-row-detail">
            <span className="ref-row-chip tabular-nums">
              All-time score {score}/{unlockScoreThreshold}
            </span>
            <span className={`ref-row-chip${betPlaced ? " ref-row-chip-done" : ""}`}>
              {betPlaced ? "Bet placed" : "Bet needed"}
            </span>
            <span className="ref-row-progress-track" aria-hidden>
              <span style={{ width: `${progress}%` }} />
            </span>
          </div>
        ) : item.status === "cancelled" ? (
          <div className="ref-row-detail">
            <span className="ref-row-chip ref-row-chip-cancelled">No payout</span>
          </div>
        ) : null}
      </div>

      <div className="ref-row-end">
        {rowDate ? (
          <span className="ref-row-date">
            <em>{rowDate.label}</em>
            <strong className="tabular-nums">{rowDate.text}</strong>
          </span>
        ) : null}
        <strong
          className={`ref-row-cash tabular-nums${
            isRewarded ? " ref-row-cash-earned" : ""
          }${item.status === "cancelled" ? " ref-row-cash-muted" : ""}`}
        >
          {rewardLabel}
        </strong>
        {isPending ? (
          <button
            type="button"
            className={`ref-row-claim${canClaim ? "" : " ref-row-claim-locked"}`}
            onClick={() => onClaim?.(item)}
            disabled={!canClaim || claiming}
          >
            {claiming ? <Loader2 size={12} className="animate-spin" /> : null}
            {canClaim ? "Claim" : "Locked"}
          </button>
        ) : null}
      </div>
    </article>
  );
};

export default ReferralListRow;
